'use client';

import { useContext } from 'react';
import { AudioContext } from '../providers/AudioProvider';

/**
 * Hook to access audio context for playing sounds.
 * @returns Audio context value with playSound, isMuted, setMuted, and toggleMuted.
 */
export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) throw new Error('useAudio must be used within an AudioProvider');
  return context;
};
